
import {is_production_mode} from "../server/utils/execute-mode";
import { sprintf } from "sprintf-js";

const StatementTypes = {
  MONTHLY: "MONTHLY",
  '1099': "1099",
  TRADE_CONFIRMATIONS: "TRADE_CONFIRMATIONS",
}

const TDA_STATEMENTS_ROOT = is_production_mode() ? "TDA_statements_prod" : "TDA_statements_dev";

const monthly_statement_path = (wlf_id, identity_id, index, year, month) => {
  return sprintf("%s/%s/%s/%04d/monthly/%04d/%04d_%02d.pdf",
    TDA_STATEMENTS_ROOT,
    wlf_id,
    identity_id,
    index,
    year,
    year,
    month);
}

const _1099_statement_path = (wlf_id, identity_id, index, year) => {
  return sprintf("%s/%s/%s/%04d/1099/1099_%04d.pdf",
    TDA_STATEMENTS_ROOT,
    wlf_id,
    identity_id,
    index,
    year);
}
export { StatementTypes, TDA_STATEMENTS_ROOT, monthly_statement_path,
  _1099_statement_path };
